export const DOWNLOAD_APP_LINK = 'DOWNLOAD_APP_LINK';

export enum STATE_DOWNLOAD_APP_PROMPT {
    IS_HIDDEN = 'IS_HIDDEN',
    NEED_TO_SHOW = 'NEED_TO_SHOW'
}
